import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styles from './styles'
import { CoreButton } from '../core'
import { setViewModeAction } from 'src/reducers/collection/action'

const CollaboratorCollectionEmptyState = ({ classes }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleViewChange = () => {
    dispatch(setViewModeAction('personal'))
    history.push('/collections/your-collections')
  }

  return (
    <div className={classes.root}>
      <img src="/assets/no-collection-shared.svg" width={192} height={180} />
      <div className={classes.texts}>
        <Typography className={classes.header}>
          There is no <span className={classes.section}>learning path</span>{' '}
          shared with you.
        </Typography>
        <Typography fontSize="14px" fontWeight={500} className={classes.title}>
          Any learning paths that others share with me will show up here.
        </Typography>
      </div>
      <CoreButton onClick={handleViewChange}>View my learning paths</CoreButton>
    </div>
  )
}

export default withStyles(styles)(CollaboratorCollectionEmptyState)
